export class ShareToggle {
    constructor() {
        this.shareWrapper = document.querySelector('.share-wrapper');
        this.shareButton = this.shareWrapper ? this.shareWrapper.querySelector('#social-share-button') : null;

        if (this.shareWrapper && this.shareButton) {
            this.init();
        }
    }

    init() {
        this.shareButton.addEventListener('click', () => this.toggleActiveClass());
    }

    toggleActiveClass() {
        this.shareWrapper.classList.toggle('active');
    }
}